import { AlertIcon } from "@signet/ui";
import type { NowCardData } from "@signet/web-kit";
import { ULink } from "./shared.tsx";
import "./now.css";

/* The Uploader's card on the Now screen: an engine that needs a person. */

export function HealthNowCard({ card }: { card: NowCardData }) {
  const data = card.data as { tone: string; reasons: string[] };
  return (
    <section className={`panel now-card${data.tone === "bad" ? " up-now-alert" : ""}`}>
      <div className="panel-head">
        <h2>{card.title}</h2>
      </div>
      <div className="panel-body up-now-health" role="status">
        <span className="up-now-mark" aria-hidden="true"><AlertIcon size={16} /></span>
        <div className="up-now-copy">
          {data.reasons.map((r) => <p key={r}>{r}</p>)}
          <ULink to="/uploader/health" className="secondary-button tiny">Open upload system health</ULink>
        </div>
      </div>
    </section>
  );
}
